var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "CustomRuleModal",
    {
      staticClass: "modal-app-upgrade",
      attrs: {
        name: _vm.modalName,
        "show-close": true,
        "cover-closeable": true,
        "cover-handler": _vm.handleCloseCover,
      },
      on: { modalClose: _vm.handleClose },
    },
    [
      _c(
        "div",
        {
          staticClass: "content",
          attrs: { slot: "modal-content" },
          slot: "modal-content",
        },
        [
          _c("div", { staticClass: "ruleTitle" }, [_vm._v("活动规则")]),
          _vm._v(" "),
          _c("div", { staticClass: "contentBox" }, [
            _c("div", {
              staticClass: "ruleContont",
              style: {
                backgroundImage: `url(${_vm.ruleContont})`,
                height: _vm.Height,
              },
            }),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }